import React from "react";
import InklndWhiteLogo from "../images/inkind-logo-white.svg";

interface NonOfferBrandLogoProps {
  brandLogo: string | null;
}
export const NonOfferBrandLogo: React.FC<NonOfferBrandLogoProps> = ({
  brandLogo,
}) => {
  return (
    <>
      {brandLogo && (
        <img src={brandLogo} alt="brand logo" className="brand-logo" />
      )}
      <div className="non-offer-brand-logo-text">
        <span>Accepts</span>
        <img src={InklndWhiteLogo} alt="inkind logo" className="inkind-logo" />
        <span>Rewards</span>
      </div>
    </>
  );
};
